import React from 'react';
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'pro' | 'top' | 'featured' | 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'outline';
  size?: 'sm' | 'md';
}
export function Badge({
  children,
  variant = 'default',
  size = 'sm',
  className = '',
  ...props
}: BadgeProps) {
  const baseStyles = 'inline-flex items-center font-medium rounded-full whitespace-nowrap shrink-0';
  const variants = {
    default: 'bg-slate-100 text-slate-700',
    pro: 'bg-indigo-100 text-indigo-700',
    top: 'bg-amber-100 text-amber-700',
    featured: 'bg-emerald-100 text-emerald-700',
    success: 'bg-emerald-50 text-emerald-600 border border-emerald-200',
    warning: 'bg-amber-50 text-amber-600 border border-amber-200',
    error: 'bg-rose-50 text-rose-600 border border-rose-200',
    info: 'bg-blue-50 text-blue-600 border border-blue-200',
    neutral: 'bg-slate-50 text-slate-600 border border-slate-200',
    outline: 'bg-transparent text-slate-600 border border-slate-300'
  };
  const sizes = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1'
  };
  return <span className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-17819">
      {children}
    </span>;
}